import { DefaultErrorPageFrame, Head } from "@dreambigger/design-system";
import { FinancialInstitutionBootstrap } from "@dreambigger/shared/src/types";
import Image from "next/image";
import { useRouter } from "next/router";

type FinancialInstitutionUnauthorizedPageProps = {
  financialInstitutionBootstrap: FinancialInstitutionBootstrap;
};

const FinancialInstitutionUnauthorizedPage = ({
  financialInstitutionBootstrap: { name, skins },
}: FinancialInstitutionUnauthorizedPageProps) => {
  const router = useRouter();
  const skinCode = router.locale;

  const skin = skins?.find((skin) => skin.code === skinCode) || skins?.[0];

  const head = {
    ...skin?.head,
    title: name,
    description: `Unauthorized - ${name}`,
  };

  return (
    <>
      <Head {...head} />
      <DefaultErrorPageFrame>
        <div
          style={{
            width: "250px",
            height: "250px",
            position: "relative",
          }}
        >
          <Image
            src={skin?.brand.primaryLogo || ""}
            alt="logo"
            layout="fill"
            objectFit="scale-down"
          />
        </div>
        <Image
          src="https://res.cloudinary.com/cotribute/image/upload/v1714547634/resources/401-lock.svg"
          alt="lock icon"
          width={150}
          height={150}
          objectFit="scale-down"
        />
        <h1 className="sm_f-12 textPrimary fwb">401</h1>
        <h1 className="sm_f-7 textPrimary fwb">Unauthorized</h1>
        <p className="sm_f-5 textPrimary fwb">
          You do not have the necessary permissions to view this page.
        </p>
      </DefaultErrorPageFrame>
    </>
  );
};

export default FinancialInstitutionUnauthorizedPage;
